import { createFileRoute } from '@tanstack/react-router';

import { AddStatusCode } from '@/features/status-codes/components/AddStatusCode';

export const Route = createFileRoute('/_auth/status-codes/add')({
  component: AddStatusCodePage,
});

/**
 * Add Status Code page — form for creating a new status code
 * with automations, group selection, and type-of-action toggle.
 */
function AddStatusCodePage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <AddStatusCode />
    </div>
  );
}
